import { preffixTestIds } from 'utility/e2e'

export const DigitalTwinBuyTestIds = preffixTestIds('digital-twin-buy')({
  QUOTE_OPTION: 'quote',
})
